export default {"src":"/_next/static/media/back.49d694c9.svg","height":512,"width":512};